import React from 'react';
import classNames from 'classnames';
// eslint-disable-next-line import/no-unresolved
import { useInstantSearch } from 'react-instantsearch-next';

const SearchCount = ({ title, indexClick, selectedOption, id }) => {
  const { results } = useInstantSearch();

  if (!results || results?.nbHits === 0) {
    return null;
  }

  const isSelected = selectedOption === id;

  return (
    <div className="px-0 py-1.5 max-[767px]:p-0 hover:text-brand">
      <button
        type="button"
        className={classNames('w-full bg-white text-center lg:text-left', {
          'font-bold': isSelected,
        })}
        onClick={() => {
          if (results.nbHits) indexClick(title.toLowerCase());
        }}
      >
        {`${title} (${results.nbHits})`}
      </button>
    </div>
  );
};

export default SearchCount;
